




































import { Component, Vue } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'
import UiModal from '@/components/semantic-ui/Modal.vue'

import HeaderBar from '@/components/HeaderBar'
import HeaderFilterInput from '@/components/HeaderFilterInput'

import grocery from '@/store/modules/grocery'

import BrandList from './components/BrandList.vue'

@Component({
	components: {
		BrandList,
		HeaderBar,
		HeaderFilterInput,
		UiButton,
		UiModal,
	},
})
export default class BrandsPage extends Vue {

	$refs!: {
		'create-brand-modal': UiModal
	}

	filter = ''

	newBrandName = ''

	createNewBrand(): boolean {

		grocery.addBrand(this.newBrandName)

		this.newBrandName = ''

		return true
	}

	showCreateBrandModal(): void {

		this.$refs['create-brand-modal'].show()
	}

}

